/**
 * created by lei lei
 * 用户访问日志
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {HEADER_HEIGHT} from "../../constants";
import {Input, Select, Button, DatePicker, Pagination,Modal} from 'antd';
import CustomTable, {TitleIcon} from "../components/customTable/CustomTable";
import *as Actions  from"../../actions/visitLog"
import {formateData,createFromData} from "../../actions/index";
import {Scrollbars} from "react-custom-scrollbars";

const {RangePicker} = DatePicker;
const {Search} = Input;
const {Option} = Select;
export default class VisitLog extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            ip: '',
            account: '',
            startTime: null,
            endTime: null,
            pageNum: 1,
            pageSize: 10,
            dataList:[],
            count:0,
            everyList:[],
            currentPage:1,
            currentPageSize:10,
            currentCount:0,

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getList();
    }
    getList(){
        let startTime = this.state.startTime ? this.state.startTime.format('YYYY-MM-DD') + ' 00:00:00' : null;//YYYY-MM-DD HH:mm:ss
        let endTime = this.state.endTime ? this.state.endTime.format('YYYY-MM-DD') + ' 23:59:59' : null;
        let body={
            start: this.state.pageNum,
            size: this.state.pageSize,
        };
        if(startTime){
            body.startTime=startTime;
            body.endTime=endTime;
        }
        if(this.state.ip){
            body.ip=this.state.ip;
        }
        if(this.state.account){
            body.account=this.state.account;
        }
        Actions.visitLog(body,res=>{
            let data=[];
            let count=0;
            if(res&&res.data){
                data=res.data;//数据
                count=res.count;
            }
            this.setState({
                dataList:data,
                count:count
            })
        })
    }

    render() {
        let height = document.body.clientHeight - HEADER_HEIGHT; //浏览器窗口的内部高度-顶部导航的高度(上部分70)
        return (
            <div style={{margin: "20px"}}>
                <div style={{
                    backgroundColor: "#fff",
                    width: "100%",
                    height: height - 40
                }}>
                    <div
                        style={{
                            width: "100%",
                            height: "42px",
                            lineHeight: "42px",
                            padding: "0 15px",
                            borderBottom: "1px solid #f6f6f6",
                            color: "black",
                            borderRadius: "2px 2px 0 0",
                            fontSize: "16px",
                            fontWeight: "bold",
                        }}
                    >
                        用户访问日志
                    </div>
                    <div style={{padding: 20}}>
                        {this.renderHead()}
                    </div>
                    {this.renderContent()}
                </div>

            </div>
        )
    }

    renderHead() {
        return (
            <div style={{display: 'flex'}}>
                <div style={{marginLeft: 20}}><Search
                    placeholder="搜索账号"
                    value={this.state.account}
                    onChange={(e) => {
                        this.setState({account: e.target.value})
                    }}
                    onSearch={value => this.onSearch()}
                    style={{width: 200}}
                /></div>
                <div style={{marginLeft: 20}}><Search
                    placeholder="搜索ip"
                    value={this.state.ip}
                    onChange={(e) => {
                        this.setState({ip: e.target.value})
                    }}
                    onSearch={value => this.onSearch()}
                    style={{width: 200}}
                /></div>
                <div style={{marginLeft: 20}}>
                    <RangePicker  value={[this.state.startTime, this.state.endTime]}
                                  format={"YYYY-MM-DD"}
                                  onChange={(date, dateString) => {
                                      this.state.startTime = date[0];
                                      this.state.endTime = date[1];
                                      this.typeChange();
                                  }} />
                </div>
                <Button style={{marginLeft: 20}} type="primary" onClick={()=>this.typeChange()}>查询</Button>
                <Button style={{marginLeft: 20}} type="primary" onClick={()=>this.revert()}>重置</Button>
            </div>
        )
    }

    renderContent() {
        let titleKeyList =
            [
                {
                    key: 'account',
                    titleName: '账号',
                    width: 150,
                    align: 'left',
                },
               {
                key: 'ip',
                titleName: 'ip',
                width: '13%',
            }, {
                key: 'time',
                titleName: '请求时间',
                width: '13%',
                render:(record)=>{
                   return(
                       <div>{record.time?window.formatDate(record.time):''}</div>
                   )
               }
            }, {
                key: 'sessionId',
                titleName: 'sessionId',
                width: '13%',
                ellipsis:true,
            }, {
                key: 'url',
                titleName: '请求地址',
                width: '13%',
                ellipsis:true,
            }, {
                key: 'params',
                titleName: '请求参数',
                width: '13%',
                ellipsis:true,
            }, {
                key: 'returnData',
                titleName: '返回结果',
                width: '13%',
                ellipsis:true,
            }, {
                key: 'takeupTime',
                titleName: '响应时长',
                width: '13%',
                /*render:(record)=>{
                    return(
                        <div>{record.time?window.formatDate(record.time):''}</div>
                    )
                }*/
            },];

        let height=document.body.clientHeight - HEADER_HEIGHT-200; //浏览器窗口的内部高度-顶部导航的高度(上部分70)
        return (
            <div>
                <div style={{height:height}}>
                    <Scrollbars>
                        <CustomTable
                            dataSource={this.state.dataList}
                            titleKeyList={titleKeyList}
                            //下面属性参考antd table  属性去使用对外暴露，会全部引用用antd 的属性。
                            pagination={false}
                            onRow={(record, index) => {
                                return {
                                    onClick: event => {
                                        console.log('onclickItem', record, index)
                                    }, // 点击行
                                    onDoubleClick: event => {
                                    },
                                    onContextMenu: event => {
                                    },
                                    onMouseEnter: event => {
                                    }, // 鼠标移入行
                                    onMouseLeave: event => {
                                    },
                                };
                            }}
                            locale={{emptyText: '暂无数据'}}

                        />
                    </Scrollbars>
                </div>
                <div style={{float:'right',marginRight:20}}>
                    <Pagination
                        showQuickJumper
                        // defaultCurrent={2}
                        current={this.state.pageNum}
                        pageSize={this.state.pageSize}
                        total={this.state.count}
                        showTotal={total => `共 ${total} 条`}
                        /*  showSizeChanger*/
                        onChange={(page, pageSize) => this.onPaginationChange(page, pageSize)}
                        onShowSizeChange={(page, pageSize) => {
                            this.onPaginationChange(page, pageSize)
                        }}
                    />
                </div>

            </div>
        )
    }



    onPaginationChange(page, pageSize){
        this.state.pageNum=page;
        this.state.pageSize=pageSize;
        this.typeChange()
    }
    onSearch(){
        this.state.pageNum=1;
        this.typeChange();
    }

    typeChange() {
        this.getList()
    }

    revert(){
        this.setState({ip: '',
            account: '',
            startTime: null,
            endTime: null,
            pageNum: 1,
            pageSize: 10,},()=>{
            this.typeChange()
        })

    }
}